// Anchored at both ends: rta/settings, qa/settings and campaign ids never match.
const AGENT_SETTINGS_ROUTE =
  /^\/accounts\/[^/]+\/assistants\/[^/]+\/settings(\/(personality|behavior|whitelist|billing))?\/?$/;

export function isAgentSettingsPath(pathname: string): boolean {
  return AGENT_SETTINGS_ROUTE.test(pathname);
}
